module.exports = __webpack_public_path__ + "img/82.7.Chla.c1723ac4.png";